<template>
  <div>
    <highcharts :options="chartOptions"></highcharts>
    <v-server-table ref="serverTable" :columns="columns" :options="options">
      <span slot="profile" slot-scope="props" class="text-center">
        {{ props.row.profile.last_name }} {{ props.row.profile.name }} {{ props.row.profile.second_name }}
      </span>
      <span slot="status" slot-scope="props">
        <center>
          <b-badge v-if="props.row.status == 0">Создан</b-badge>
          <b-badge variant="primary" v-if="props.row.status == 1">В процессе расчёта</b-badge>
          <b-badge variant="success" v-if="props.row.status == 2">Расчитан</b-badge>
          <b-badge variant="danger" v-if="props.row.status == 3">Возникли ошибки</b-badge>
        </center>
      </span>
      <span slot="created_at" slot-scope="props">
        {{ parseInt(props.row.created_at) | moment("timezone", $moment.tz.guess(), "lll") }}
      </span>
      <span slot="actions" slot-scope="props">
        <center>
          <router-link :to="'/risk/' + props.row.id" class="m-1"><i class="fa fa-2x fa-eye"></i></router-link>
        </center>
      </span>
    </v-server-table>
    <b-modal id="viewProject" ref="viewProject" title="Просмотр проекта" size="xl" hide-footer>
      <risk v-if="projId" :projId="projId"></risk>
    </b-modal>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
export default {
  props: {
    projects: Array,
  },
  components: {
    highcharts: Chart,
  },
  data() {
    return {
      chartOptions: {
        chart: {
          type: "column",
        },
        title: {
          text: "Распределение созданных проектов",
        },
        subtitle: {
          text: "Ночь - работе не помеха!",
        },
        xAxis: {
          categories: ["Все", "Год", "Квартал", "Месяц"],
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: "Количество, шт.",
          },
        },
        tooltip: {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat:
            '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y}</b></td></tr>',
          footerFormat: "</table>",
          shared: true,
          useHTML: true,
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        series: [
          {
            name: "Общее количество",
            data: [],
          },
          {
            name: "Расчитаны",
            data: [],
          },
        ],
      },
      columns: ["id", "name", "address", "created_at", "profile", "status", "actions"],
      options: {
        headings: {
          selected: "#",
          id: "ИД",
          name: "Название",
          address: "Адрес",
          created_at: "Дата создания",
          profile: "Пользователь",
          status: "Статус",
          actions: "Действия",
        },
        skin: "table table-sm table-striped table-bordered table-hover",
        filterByColumn: true,
        filterable: ["id", "name", "address", "profile", "status"],
        sortable: ["id", "name", "address", "profile", "status"],
        sortIcon: { base: "fa", up: "fa-chevron-up", down: "fa-chevron-down", is: "fa-sort" },
        perPage: 25,
        debounce: 1000,
        perPageValues: [10, 25, 50, 100],
        responseAdapter: function (resp) {
          const newResp = this.getResponseData(resp);
          this.$parent.roles = newResp.data.roles;
          return { data: newResp.data.projects, count: newResp.data.count };
        },
        requestFunction: function (data) {
          return this.$http
            .post("admin/projects/get?page=" + data.page + "&per_page=" + data.limit, {
              event_id: this.$route.params.id,
              page: data.page,
              query: data.query,
              sort: data.orderBy,
              ascending: data.ascending,
            })
            .catch(
              function (e) {
                this.dispatch("error", e);
              }.bind(this)
            );
        },
        texts: {
          count: "Показано с {from} по {to} из {count} записей|{count} записей|Одна запись",
          first: "Начало",
          last: "Конец",
          filter: "Фильтр",
          filterPlaceholder: "Поиск",
          limit: "Записей:",
          page: "Страница:",
          noResults: "Ничего не найдено",
          filterBy: "{column}",
          loading: "Загрузка...",
          defaultOption: "Выбрано {column}",
          columns: "Колонки",
        },
      },
    };
  },
  methods: {
    getChart() {
      this.$http.get("admin/projects/statistics").then((response) => {
        // JSON responses are automatically parsed.
        for (var count of response.data.count) {
          this.chartOptions.series[0].data.push(parseInt(count));
        }
        for (var calculated of response.data.calculated) {
          this.chartOptions.series[1].data.push(parseInt(calculated));
        }
        console.log(this.chartOptions);
      });
    },
  },
  created() {
    this.getChart();
  },
};
</script>
